export default __webpack_public_path__ + "static/media/subtitle-caption.b5014c9f.svg";